module.exports = __webpack_public_path__ + "static/media/weaknessIcon.dd524dec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/weaknessIcon.png
// module id = 1489
// module chunks = 0